import * as React from "react";


export default class Embed extends React.Component {
    // model props
    constructor(props) {
        super(props);

    }

    render() {
        const { model } = this.props;
        return (
            <div className="embedded-content"
                dangerouslySetInnerHTML={{ __html: model.value }}
            >
            </div>
        );
    }
}